import { KeywordAnalysisNodeSettings } from "./KeywordAnalysisNodeSettings";
import { AnalysisType } from "../../models/analysisNode";

export const AnalysisNodeTypeSettings = {
  [AnalysisType.param_extraction]: (props) => (
    <KeywordAnalysisNodeSettings {...props} />
  ),
};
